import { SurgeonDetails } from '../components';
import { useSurgeonsByRawRegion } from '../hooks';

export const SurgeonDrawer = ({
  regionName,
  isOpen,
  onClose,
}: {
  regionName: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const surgeons = useSurgeonsByRawRegion(regionName);

  return (
    <SurgeonDetails
      isOpen={isOpen}
      onClose={onClose}
      regionName={regionName}
      data={surgeons}
    />
  );
};
